// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__c20AM","heading":"Terms_heading__8Wb7T","terms":"Terms_terms__d98oS","headingSecondry":"Terms_headingSecondry__AcRm0","content":"Terms_content__8uF1e"};